import mutations from './commonMutations';
import getters from './commonGetters';
import actions from './commonActions';

const state = {
  isFoldMenu: false,
  helpObj: {
    title: '',
    content: '',
  },
  helpObjList: [],
  editorContentStyle: `
  <style>
  :host{
    border-collapse:separate;
    border-spacing:0;
    caption-side:top;
    color:#000;
    cursor:auto;
    empty-cells:show;
    font-style:normal;
    font-variant:normal;
    font-weight:100;
    letter-spacing:normal;
    line-height:normal;
    list-style-image:none;
    list-style-position:outside;
    list-style-type:disc;
    orphans:2;
    overflow-wrap:normal;
    resize:none;
    text-align:left;
    text-indent:0;
    text-shadow:none;
    text-transform:none;
    visibility:visible;
    white-space:normal;
    word-spacing:0;
    word-break:normal;
    word-wrap:normal
  }
  :host, :host *, *::before, *::after{
    align-content:stretch;
    align-items:stretch;
    align-self:auto;
    animation-delay:0s;
    animation-direction:normal;
    animation-duration:0s;
    animation-fill-mode:none;
    animation-iteration-count:1;
    animation-name:none;
    animation-play-state:running;
    animation-timing-function:ease;
    backface-visibility:visible;
    background-attachment:scroll;
    background-clip:border-box;
    background-color:transparent;
    background-image:none;
    background-origin:padding-box;
    background-position:0 0;
    background-repeat:repeat;
    background-size:auto;
    border:0 none #000;
    border-image-outset:0;
    border-image-repeat:stretch;
    border-image-slice:100%;
    border-image-source:none;
    border-image-width:1px;
    border-radius:0;
    bottom:auto;
    box-sizing:content-box;
    column-count:auto;
    column-gap:normal;
    column-rule-color:#000;
    column-rule-style:none;
    column-rule-width:0;
    column-width:auto;
    clear:none;
    clip:auto;
    content:none;
    counter-increment:none;
    counter-reset:none;
    display:inline;
    dominant-baseline:auto;
    flex-basis:auto;
    flex-direction:row;
    flex-grow:0;
    flex-shrink:1;
    flex-wrap:nowrap;
    font-stretch:normal;
    justify-content:flex-start;
    left:auto;
    margin:0;
    max-height:none;
    max-width:none;
    opacity:1;
    order:0;
    outline-color:#000;
    outline-offset:0;
    outline-style:none;
    outline-width:0;
    overflow:visible;
    overflow-x:visible;
    overflow-y:visible;
    padding:0;
    page-break-after:auto;
    page-break-before:auto;
    page-break-inside:auto;
    perspective:none;
    perspective-origin:0 0;
    position:static;
    right:auto;
    tab-size:8;
    table-layout:auto;
    text-decoration:none;
    text-overflow:clip;
    top:auto;
    transform:none;
    transform-origin:0 0;
    transform-style:flat;
    transition-delay:0s;
    transition-duration:0s;
    transition-property:all;
    transition-timing-function:ease;
    unicode-bidi:normal;
    vertical-align:baseline;
    z-index:auto
  }
  :host,:host *,:host * x:-moz-any-link,:host x:-moz-any-link{
    box-shadow:none
  }
  @media screen and (-webkit-min-device-pixel-ratio:0){
    :host,:host *{
        box-shadow:none
    }
  }
  :host a[href]{
    -moz-column-rule-color:#00e;
    -webkit-column-rule-color:#00e;
    column-rule-color:#00e;
    border-color:#00e;
    outline-color:#00e;
    color:#00e;
    text-decoration:underline;
    cursor:auto
  }
  :host a[href]:active{
    -moz-column-rule-color:#551a8b;
    -webkit-column-rule-color:#551a8b;
    column-rule-color:#551a8b;
    border-color:#551a8b;
    outline-color:#551a8b;
    color:#551a8b
  }
  :host b,:host strong{
    font-weight:700
  }
  :host div{
    display:block;
    position:static
  }
  :host em,:host i{
    font-style:italic
  }
  :host h1{
    display:block;
    font-size:2em;
    margin:.67em 0;
    font-weight:700
  }
  :host h2{
    display:block;
    font-size:1.5em;
    margin:.83em 0;
    font-weight:700
  }
  :host h3{
    display:block;
    font-size:1.17em;
    margin:1em 0;
    font-weight:700
  }
  :host h4{
    display:block;
    margin:1.33em 0;
    font-weight:700
  }
  :host h5{
    display:block;
    font-size:.83em;
    margin:1.67em 0;
    font-weight:700
  }
  :host h6{
    display:block;
    font-size:.67em;
    margin:2.33em 0;
    font-weight:700
  }
  :host hr{
    display:block;
    margin:.5em auto;
    border-color:#eee;
    border-style:inset;
    border-width:1px;
    box-sizing:border-box
  }
  :host iframe{
    border-image:initial
  }
  :host li{
    display:list-item;
    text-align:left
  }
  :host mark{
    background-color:#ff0;
    color:#000
  }
  :host ul{
    display:block;
    list-style-type:disc;
    padding-left:40px
  }
  :host ol{
    display:block;
    list-style-type:decimal;
    padding-left:40px
  }
  :host ol ul,:host ul ul{
    list-style-type:circle
  }
  :host ol ol ul,:host ol ul ul,:host ul ol ul,:host ul ul ul{
    list-style-type:square
  }
  :host p{
    display:block;
    margin:1em 0
  }
  :host s,:host strike{
    text-decoration:line-through
  }
  :host small{
    font-size:smaller
  }
  :host sub{
    vertical-align:sub;
    font-size:.83em
  }
  :host sup{
    vertical-align:super;
    font-size:.83em
  }
  :host u{
    text-decoration:underline
  }
  :host table{
    display:table;
    border-collapse:separate;
    border-spacing:2px;
    border-color:gray
  }
  :host thead{
    display:table-header-group;
    vertical-align:middle;
    border-color:inherit
  }
  :host tbody{
    display:table-row-group;
    vertical-align:middle;
    border-color:inherit
  }
  :host table>tr{
    vertical-align:middle
  }
  :host col{
    display:table-column
  }
  :host colgroup{
    display:table-column-group
  }
  :host tr{
    display:table-row;
    vertical-align:inherit;
    border-color:inherit
  }
  :host td,:host th{
    display:table-cell;
    vertical-align:inherit
  }
  :host th{
    font-weight:700
  }
  :host a,:host b,:host col,:host colgroup,:host div,:host em,:host font,:host h1,:host h2,:host h3,:host h4,:host h5,:host h6,:host hr,:host i,:host li,:host mark,:host ol,:host p,:host s,:host small,:host span,:host strike,:host string,:host sub,:host sup,:host table,:host tbody,:host td,:host th,:host thead,:host tr,:host u,:host ul{
    width:auto;
    height:auto
  }
  :host head,:host link,:host meta,:host param,:host script,:host style,:host title{
    display:none
  }
  :host table[align=center]{
    margin-left:auto;
    margin-right:auto
  }
  </style>
  `,
};

export default {
  state,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/vuex/common/common/commonStore.js